import React from 'react';

import {
  Card,
  CardContent,
  CardMedia,
  Grid,
  Typography,
} from '@material-ui/core';

import checkboxAnswer from '../../../../../../assets/img/prelogin/checkboxAnswer.svg';
// import checkboxAnswer from "../../../../../../assets/img/prelogin/checkboxAnswer.png";
import { useStyles } from './style';

interface FeatureCardProps {
  img: string;
  description: string;
}

const FeatureCard = ({ img, description }: FeatureCardProps) => {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardMedia className={classes.cardImage} component="img" image={img} />
      <CardContent>
        <Grid direction="row" container alignItems="center">
          <Grid item xs={1}>
            <CardMedia
              className={classes.checkbox}
              component="img"
              image={checkboxAnswer}
            />
          </Grid>
          <Grid item xs={11}>
            <Typography className={classes.description}>
              {description}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

FeatureCard.displayName = 'FeatureCard';

export default FeatureCard;
